// Port of api/fuel/app/classes/filter/search/games/rules/query/has_play_report.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'has_play_report',
	match: function(rule, config, filter, data, query) {
		query.where('p.user_id', 'in', data.users)
		query.where('p.play_comment', '<>', '')

		if (rule.logic.value === 'yes') {
			query.exist('play', 'p')
		} else if (rule.logic.value === 'no') {
			query.notexist('play', 'p')
		}
	}
})
